import { useEffect, useState } from "react";
import Top from "../top2/index";
import Bottom from "../bottom2/index";
import Preview from "../preview2/index";
import { getAreaInt } from "../../../../services/public/areas";
import { getAreapCook } from "../../../../utils/params";
import Toasts from "../../../toast";


function Center() 
{
  const [OpcMens, setOpcMens] = useState("");
  const [Areas, setAreas] = useState([]);
  const [Empresa, setEmpresa] = useState([]);
  const [opciones, setOpciones] = useState([]);
  const [Ruta, setRuta] = useState("");
  const [showToast, setShowToast] = useState(false);

  const GenerarRutaArch = (Datos) => 
    {
      const ItemId = Datos.ItemId;
      const ArchivoId = Datos.ArchivoId;
      const Formato = Datos.Formato;
      const NombreArch = ArchivoId + "_" + ItemId + "." + Formato;
      const RutaArch =  "/api/static/" + Datos.RutaArch + "/" + NombreArch;
      setRuta(RutaArch);
    };

  useEffect(() => 
    {
      const ParamsPantalla = async () => 
        {
          const AreaId = getAreapCook();
          const response = await getAreaInt(AreaId);
      
          if (response) 
            {
             if (response.status === 200) {
          setAreas(response.data.data[0]);
          setOpcMens(response.data.data[0].MensajeInf);
          setEmpresa(response.data.empresa[0]);
          await GenerarRutaArch(response.data.empresa[0]);
        }
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    };
  
    ParamsPantalla();
  }, []);

  return (
     <>  
       <div className="flex flex-col w-full h-screen bg-body overflow-hidden">
          {Areas ? <Top areas={Areas} empresa={Empresa} ruta={Ruta} /> : ""}
          <Preview />
           {OpcMens === "SI" ? <Bottom /> : ""}
       </div>
        {showToast && (
          <Toasts
             type={opciones.type}
             message={opciones.message}
             active={opciones.active}
          ></Toasts>
        ) 
        }
  </>
  );
}
    
export default Center;
